import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { message } from "antd";
import axiosHttp from "services/axiosHttp";

// Real backend confirmed: POST /assets -> ResponseHandler.sendSuccessResponse
// wraps the created asset in a `data` key: { status, message, data: { id, asset_number, name, status, created_at } }
// onCreated (optional): called with the created asset instead of going back to the list.
export const createAsset = createAsyncThunk("createAsset", async ({ data, form, history, onCreated }) => {
	const response = await axiosHttp.post(`assets`, data);
	const created = response.data?.data ?? response.data;

	form.resetFields();
	message.success(`Asset ${created?.asset_number ?? ""} successfully registered!`);
	if (onCreated) onCreated(created);
	else history("/app/asset-management");
	return created;
});

const AssetCreateSlice = createSlice({
	name: "assetCreateSlice",
	initialState: {
		isLoading: false,
		error: null,
	},
	extraReducers: (builder) => {
		builder.addCase(createAsset.pending, (state) => {
			state.isLoading = true;
		});
		builder.addCase(createAsset.fulfilled, (state, action) => {
			state.isLoading = false;
			state.data = action.payload;
		});
		builder.addCase(createAsset.rejected, (state, action) => {
			state.isLoading = false;
			state.error = action.payload;
		});
	},
});

export default AssetCreateSlice.reducer;